import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';

import '@/utilities/i18n';
import '@/style/app.scss';

import store from "./store";
import { RouterProvider } from "react-router-dom";
import router from './routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch